import React from 'react';
import type { SxProps } from '@mui/material';
import { Box, Dialog, DialogTitle, Typography } from '@mui/material';

/** Styles for Dialog's component */
const infoDialogContent: SxProps = {
    p: '2rem',
};

/**
 * Dialog Component that allows to interact with the user
 */
export default ({ title, text, children, open, handleClose }: IInfoDialogProps) => {
    return (
        <Dialog onClose={handleClose} open={open}>
            {title && <DialogTitle>{title}</DialogTitle>}
            <Box sx={infoDialogContent}>
                {children}
                {text && <Typography variant="h5">{text}</Typography>}
            </Box>
        </Dialog>
    );
};

/**
 * Interface that describes InfoDialog's props.
 */
interface IInfoDialogProps extends React.PropsWithChildren<unknown> {
    title?: string;
    text?: string;
    open: boolean;
    handleClose?: (open: boolean) => void;
}
